import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

export interface AssistantBehaviourEvent {
  action: AssistantEventActionEnum;
  currentPopover: NgbPopover;
}

export enum AssistantEventActionEnum {
  CLOSE_OTHERS
}
